<template>
  <div class="car" id="car">
    <div v-if="type === 'car'">
      <table class="table">
        <thead>
        <tr>
          <th>货号</th>
          <th>品牌</th>
          <th>渠道</th>
          <th>尺码</th>
          <th>发布季</th>
          <th>库存</th>
          <th>数量</th>
          <th>原价</th>
          <th>折扣</th>
          <th>实际单价</th>
          <th>重量（g/款）</th>
          <th>实际金额</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in goodsList" :key="index">
          <td>{{item.GoodsId}}</td>
          <td>{{item.BrandName}}</td>
          <!--<td>{{item.SupplierCode}}_{{item.StoreroomName}}</td>-->
          <td>{{item.StoreroomName}}</td>
          <td>{{item.Size}}</td>
          <td>{{item.MarketSeasoin}}</td>
          <td>{{item.Stock}}</td>
          <td class="car_number">
            <button class="btn_count" @click="changeNum(item.Id, -1)">-</button>
            <input type="text" title="数量" @keyup="blurChaNum(item.Id, item.Quantity)" v-model.trim="item.Quantity">
            <button class="btn_count" @click="changeNum(item.Id, 1)">+</button>
          </td>
          <td>{{item.MarketPrice}}</td>
          <td>{{item.AgentDiscount}}</td>
          <td>{{item.AgentCostPrice}}</td>
          <td>{{item.GoodsSkuWeight}}</td>
          <td>{{item.actualAmount}}</td>
          <td><i class="iconfont icon-del fcDel" title="删除" @click="ctrlBtn('delCarGoods', item)"></i></td>
        </tr>
        <tr>
          <td>共计</td>
          <td colspan="11" class="text_left">{{goodsList.length}}款商品，大概重量：{{weightTotal}}（g），商品总价：{{priceTotal}}元</td>
          <td><button class="btn_del" @click="ctrlBtn('clearCarGoods', 0)">清空购物车</button></td>
        </tr>
        </tbody>
      </table>

      <table class="table consignee_msg">
        <thead>
        <tr>
          <th colspan="2">收货人信息</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>地址解析：</td>
          <td>
            <textarea title="地址" v-model="addressObj.addressDetailContent" @keydown="listenCode()" @blur="addressAnalysis()"></textarea>
            <div class="address_analysis">
              <p>可以从淘宝等平台复制物流信息到这里，提高下单效率，格式要求（姓名,手机,电话,地址,邮编）</p>
              <p>例如1：张XX,13888888888,0579-88888888,浙江省 金华市 婺城区 永康街697号东侧二楼,321000</p>
              <p>例如2：张XX,13888888888,,浙江省 金华市 婺城区 永康街697号东侧二楼,321000</p>
              <p>例如3：张XX,13888888888,浙江省 金华市 婺城区 永康街697号东侧二楼,321000</p>
              <p>例如4：张XX,13888888888,浙江省 金华市 婺城区 永康街697号东侧二楼</p>
              <p class="fcDel">注:淘宝地址格式严格按照以上格式填写,省,市,区后面要有[空格]！提交不成功请检查地址格式！</p>
             <!-- <p>可以从淘宝等平台复制物流信息到这里，提高下单效率，格式要求（姓名，手机，电话，地址，邮编）</p>
              <p>例如1：张XX ，13888888888，0579-88888888 ，浙江省 金华市 婺城区 永康街697号东侧二楼 ，321000</p>
              <p>例如2：张XX ，13888888888， ，浙江省 金华市 婺城区 永康街697号东侧二楼 ，321000</p>
              <p>例如3：张XX ，13888888888，浙江省 金华市 婺城区 永康街697号东侧二楼 ，321000</p>
              <p class="fcDel">注:淘宝地址格式严格按照以上格式填写,省,市,区后面要有[空格]！提交不成功请检查地址格式！</p> -->
            </div>
          </td>
        </tr>
        <tr>
          <td><i class="fcDel">*</i>收货人姓名：</td>
          <td><input type="text" title="收货人姓名" v-model.trim="addressObj.name"></td>
        </tr>
        <tr>
          <td>邮编：</td>
          <td><input type="text" title="邮编" v-model.trim="postCode"></td>
        </tr>
        <tr>
          <td>所属地区：</td>
          <td>
            <div class="inb w_percent20">
              <el-select v-model="selectProvince" @change="getAllCityList" placeholder="省份">
                <el-option
                  v-for="item in provincesList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="inb w_percent20">
              <el-select v-model="selectCity" @change="getAllAreaList" placeholder="城市">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="inb w_percent20">
              <el-select v-model="selectArea" placeholder="城区">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </td>
        </tr>
        <tr>
          <td><i class="fcDel">*</i>详细地址：</td>
          <td>
            <textarea class="detail_address" title="详细地址" v-model="addressObj.addressContent" @blur="addressResolution(addressObj.addressContent)"></textarea>
            <div class="inb address_analysis">注:详细地址中也要输入省市县(区)（例如:浙江省 金华市 婺城区 永康街697号东侧二楼），格式严格按照以上格式填写,省,市,县（区）后面要有[空格]！</div>
          </td>
        </tr>
        <tr>
          <td><i class="fcDel">*</i>手机：</td>
          <td><input type="text" title="手机号" v-model.trim="addressObj.phone"></td>
        </tr>
        <tr>
          <td>固定电话：</td>
          <td><input type="text" title="固话" v-model.trim="tel"  @blur="telReg(tel)"></td>
        </tr>
       <!-- <tr>
          <td>客服单号：</td>
          <td><input type="text"></td>
        </tr> -->
        <tr>
          <td>备注：</td>
          <td><textarea title="备注" v-model.trim="remark"></textarea></td>
        </tr>
        </tbody>
      </table>
      <div class="text_center mt30 mb30"><button class="btn_normal" @click="checkReceiveNameHaveOrders()">去结算</button></div>
      <!--<div class="text_center mt30 mb30"><button class="btn_normal" @click="settlementOrder()">去结算</button></div>-->
    </div>

    <div class="list_msg" v-if="type === 'list'">
      <h2 class="ml30 mb10">订购清单</h2>
      <table class="table mb20" v-for="(item, index) in orderMsg.OrderList" :key="index">
        <thead>
        <tr><th colspan="12">订单号：{{item.OrderNum}}</th></tr>
        <tr>
          <th>货号</th>
          <th>品牌</th>
          <th>渠道</th>
          <th>尺码</th>
          <th>发布季</th>
          <th>库存</th>
          <th>数量</th>
          <th>原价</th>
          <th>折扣</th>
          <th>实际单价</th>
          <th>重量（g/款）</th>
          <th>实际金额</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(itemChannel, indexChannel) in item.GoodsDetailList" :key="indexChannel">
          <td>{{itemChannel.GoodsId}}</td>
          <td>{{itemChannel.BrandName}}</td>
          <td>{{itemChannel.StoreroomCodeName}}</td>
          <td>{{itemChannel.Size}}</td>
          <td>{{itemChannel.MarketSeason}}</td>
          <td>{{itemChannel.Stock}}</td>
          <td>{{itemChannel.Quantity}}</td>
          <td>{{itemChannel.MarketPrice}}</td>
          <td>{{itemChannel.AgentCostDicount}}</td>
          <td>{{itemChannel.AgentCostPrice}}</td>
          <td>{{itemChannel.GoodsWeight}}</td>
          <td>{{itemChannel.NeedPay}}</td>
        </tr>
        <tr class="logistics_top">
          <td colspan="2" :rowspan="item.ExpressList.length + 1" class="fcDel" style="background-color: #fff;width: 100px">{{item.StoreroomRemark}}</td>
          <td>物流</td>
          <td>运费</td>
          <td colspan="2">预计发货日期</td>
          <!--<td colspan="2">预计到货日期</td>-->
          <td colspan="2">首重</td>
          <td colspan="2">续重</td>
          <td colspan="2"></td>
        </tr>
        <tr v-for="(itemLogistic, indexLogistic) in item.ExpressList" :key="indexLogistic + '_' + itemLogistic.LogisticId">
          <td class="pr">
            <span v-if="itemLogistic.IsDefault" class="default">默认</span>
            <input :title="itemLogistic.LogisticName" type="radio" :name="item.OrderNum"
                   v-model="item.logisticIndex"
                   :value="indexLogistic" @change="logisticExchange(index, indexLogistic)">
            {{itemLogistic.LogisticName}}
          </td>
          <td class="fcDel">{{itemLogistic.Freight}}</td>
          <td colspan="2">{{itemLogistic.ShipDay | timeday}}</td>
          <td colspan="2">{{itemLogistic.FirstMoney}}元/{{itemLogistic.FirstWeight}}kg</td>
          <td colspan="2">{{itemLogistic.ContinueMoney}}元/{{itemLogistic.ContinueWeight}}kg</td>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td>共计</td>
          <td colspan="11" class="text_left">{{item.GoodsDetailList.length}}款商品，大概重量：{{item.GoodsWeight}}(kg),商品总价：{{item.GoodsPrice}}，运费：{{item.logisticPrice}}元</td>
        </tr>
        </tbody>
      </table>
      <div class="w_percent100 mt10 mb10">
        <span class="fl">添加订单备注：</span>
        <textarea class="w_percent76" title="备注" v-model.trim="orderMsg.Remark"></textarea>
      </div>
      <div class="list_detail">
        <p>{{orderMsg.OrderList.length}}件商品，总商品金额：{{orderMsg.AllPayMoney}}，总运费：{{orderLogisticTotal}}，应付总额：<i class="fcDel fs18">￥{{orderPriceTotal}}</i></p>
        <p>寄送至：
          <!--{{orderMsg.OrderList[0].ReceiverAddress.ProvinceName}}-->
          <!--{{orderMsg.OrderList[0].ReceiverAddress.CityName}}-->
          <!--{{orderMsg.OrderList[0].ReceiverAddress.AreaName}}-->
          {{orderMsg.OrderList[0].ReceiverAddress.Address}} &nbsp;&nbsp;&nbsp;&nbsp;
          收货人：{{orderMsg.OrderList[0].ReceiverAddress.Receiver}} &nbsp;&nbsp;&nbsp;&nbsp;
          {{orderMsg.OrderList[0].ReceiverAddress.Phone}}&nbsp;&nbsp;&nbsp;&nbsp;
          {{orderMsg.OrderList[0].ReceiverAddress.Tel}}
        </p>
      </div>
      <div class="text_center mb20">
        <div class="inb w150 mr10">
          <el-select v-model="selectSource" placeholder="来源">
            <el-option
              v-for="item in sourceList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <button class="btn_normal mr10" @click="submitOrders()">确认订购</button>
        <button class="btn_cancel" @click="cancle()">取消</button>
      </div>
    </div>

    <!--弹出框-->
    <car-embed-msg v-if="isShow"
                   :title="dialogTitle"
                   :showType="dialogShowType"
                   :carOrderMsg="carMsg"
                   @cancelbtn="getSelectDialogEmbed"></car-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import CarEmbedMsg from './car-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'car',
    components: {CarEmbedMsg, MsgDialog},
    computed: {
      goodsList: {
        get: function () {
          this.priceTotal = 0;
          this.weightTotal = 0;
          let list = this.$store.state.carGoodsList;
          if (list.length) {
            for (let i = 0; i < this.$store.state.carGoodsList.length; i++) {
              list[i].actualAmount = this.Global.multiplication(list[i].AgentCostPrice, list[i].Quantity);
              this.priceTotal = this.Global.addition(this.priceTotal, list[i].actualAmount);
              this.weightTotal = this.Global.addition(this.weightTotal, this.Global.multiplication(list[i].Quantity, list[i].GoodsSkuWeight));
            }
            // this.priceTotal = Number(this.priceTotal);
          }
          return list;
        },
        set: function () {
          this.priceTotal = 0;
          this.weightTotal = 0;
          let list = this.$store.state.carGoodsList;
          if (list.length) {
            for (let i = 0; i < this.$store.state.carGoodsList.length; i++) {
              list[i].actualAmount = this.Global.multiplication(list[i].AgentCostPrice, list[i].Quantity);
              console.log('实际金额', list[i].actualAmount);
              this.priceTotal = this.Global.addition(this.priceTotal, list[i].actualAmount);
              this.weightTotal = this.Global.addition(this.weightTotal, this.Global.multiplication(list[i].Quantity, list[i].GoodsSkuWeight));
            }
            // this.priceTotal = Number(this.priceTotal);
          }
          // return this.$store.state.carGoodsList;
          return list;
        }
      },
      rightTabsContent: {
        // getter
        get: function () {
          return this.$store.state.tabs;
        },
        // setter
        set: function (newVal) {
          this.$store.state.tabs = newVal;
          return this.$store.state.tabs;
        }
      },
      rightTabsPosition: {
        get: function () {
          return this.$store.state.tabsPosition;
        },
        set: function (newVal) {
          this.$store.state.tabsPosition = newVal;
          return this.$store.state.tabsPosition;
        }
      }
    },
    data: function () {
      return {
        type: 'list', // 类型：car=购物车状态  list=购物清单结算状态
        priceTotal: 0, // 购物车总金额
        weightTotal: 0, // 购物车总重量
        addressObj: {
          provinceName: '', // 省名
          cityName: '', // 市名
          areaName: '', // 区名
          addressName: '', // 地方详细名
          name: null, // 收货人
          phone: null, // 联系方式
          addressDetailContent: null, // 文本框详细地址的内容
          addressContent: null // 文本框的内容
        }, // 地址对象
        provincesList: [], // 省份下拉
        selectProvince: null, // 选择的省份
        cityList: [], // 城市下拉
        selectCity: null, // 选择的城市
        areaList: [], // 区下拉
        selectArea: null, // 选择的区
        postCode: null, // 邮编
        tel: '', // 固话
        remark: '', // 备注
        orderMsg: {
          AllPayMoney: 0,
          AllQuantity: 0,
          OrderList: []
        }, // 订购清单
        orderRemark: '', // 订单备注
        orderPriceTotal: 0, // 订单总金额 = 商品总金额 + 运费总金额
        orderLogisticTotal: 0, // 运费总金额
        sourceList: [], // 来源下拉框列表
        selectSource: '', // 来源选择
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      ...mapMutations(
        ['deleteCarGoods', 'updateCarGoods', 'clearCarGoods']
      ),

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.carMsg = msg;
        switch (type) {
          case 'delCarGoods':
            this.dialogTitle = '删除';
            break;
          case 'clearCarGoods':
            this.dialogTitle = '清空购物车';
            break;
          case 'settlement':
            this.dialogTitle = '提示';
            break;
        }
      },
      /** 中国大陆加港澳台手机正则验证
       * 中国大陆：开头1 3-8号段，后边跟9位数字
       * 台湾：09开头后面跟8位数字
       * 香港：9或6开头后面跟7位数字
       * 澳门：66或68开头后面跟5位数字
       * */
      phoneReg(num) {
        const reg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
        if (num.slice(0, 3) === '86-') {
          return reg.test(num.slice(3))
        } else {
          return reg.test(num);
        }
      },

      // 固话
      telephone(num) {
        const reg = /0\d{2,3}-\d{7,8}/;
        return reg.test(num);
      },

      telReg(tel) {
        if (!this.telephone(tel)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写完整的固定电话';
          this.tel = '';
        }
      },

      // 详细地址解析
      addressResolution(content) {
        if (content) {
          let provinceArr = [];
          let cityArr = [];
          let areaArr = [];
          const provinceReg = new RegExp(content.split(' ')[0]);
          const cityReg = new RegExp(content.split(' ')[1]);
          const areaReg = new RegExp(content.split(' ')[2]);
          for (let i = 0; i < this.provincesList.length; i++) {
            if (this.provincesList[i].text.match(provinceReg)) {
              provinceArr.push(this.provincesList[i]);
            }
          }
          if (provinceArr.length !== 1) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写完整的省份';
            return;
          }

          this.$axios.get(this.Global.getAllCityList(provinceArr[0].id)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cityList = res.data.resData;
              for (let i = 0; i < this.cityList.length; i++) {
                if (this.cityList[i].text.match(cityReg)) {
                  cityArr.push(this.cityList[i]);
                }
              }

              if (cityArr.length !== 1) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写完整的城市';
                return;
              }

              this.$axios.get(this.Global.getAllAreaList(cityArr[0].id)).then((areaRes) => {
                if (!areaRes.data.errorMsg.length) {
                  this.areaList = areaRes.data.resData;
                  for (let i = 0; i < this.areaList.length; i++) {
                    if (this.areaList[i].text.match(areaReg)) {
                      areaArr.push(this.areaList[i]);
                    }
                  }

                  this.addressObj.addressContent = content;
                  this.selectProvince = provinceArr[0].id;
                  this.addressObj.provinceName = provinceArr[0].text;
                  this.selectCity = cityArr[0].id;
                  this.addressObj.cityName = cityArr[0].text;

                  if (areaArr.length === 1) {
                    this.selectArea = areaArr[0].id;
                    this.addressObj.areaName = areaArr[0].text;
                  }

                  return true;

                  /* if (areaArr.length !== 1) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写完整的县（区）';
                    return false;
                  } else {
                    // this.selectProvince = this.provincesList[provinceIndex].id;
                    // this.addressObj.provinceName = content.split(' ')[0];
                    // this.selectCity = this.cityList[cityIndex].id;
                    // this.addressObj.cityName = content.split(' ')[1];
                    // this.selectArea = this.areaList[areaIndex].id;
                    // this.addressObj.areaName = content.split(' ')[2];
                    this.addressObj.addressContent = content;
                    this.selectProvince = provinceArr[0].id;
                    this.addressObj.provinceName = provinceArr[0].text;
                    this.selectCity = cityArr[0].id;
                    this.addressObj.cityName = cityArr[0].text;
                    this.selectArea = areaArr[0].id;
                    this.addressObj.areaName = areaArr[0].text;
                    return true;
                  } */
                }
              });
            }
          });
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写地址';
          return false;
        }
      },

      // 地址解析
      addressAnalysis() {
        if (this.addressObj.addressDetailContent) {
          this.addressObj.addressDetailContent = this.addressObj.addressDetailContent.replace(/[,，]/g, ',');
          if (this.addressObj.addressDetailContent.split(',').length > 3) {
            const content = this.addressObj.addressDetailContent.split(',');
            const contentLen = this.addressObj.addressDetailContent.split(',').length;
            if (contentLen === 4) {
              if (content[1] && (!this.phoneReg(content[1]) && !this.telephone(content[1]))) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的手机号';
                return;
              }
              if (content[2].split(' ').length < 3) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的地址格式';
                return;
              }
              this.addressResolution(content[2]);
              if (content[3].length !== 6) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的邮编';
                return;
              }
              this.addressObj.name = content[0];
              this.addressObj.phone = content[1];
              this.postCode = content[3];
            } else {
              if (content[1] && (!this.phoneReg(content[1]) && !this.telephone(content[1]))) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的手机号';
                return;
              }
              if (content[2] && !this.telephone(content[2])) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的固定电话';
                return;
              }
              if (content[3].split(' ').length < 3) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的地址格式';
                return;
              }
              this.addressResolution(content[3]);
              if (content[4].length !== 6) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写正确的邮编';
                return;
              }
              this.addressObj.name = content[0];
              this.addressObj.phone = content[1];
              this.tel = content[2];
              this.postCode = content[4];
            }
          } else if (this.addressObj.addressDetailContent.split(',').length === 3) {
            const content = this.addressObj.addressDetailContent.split(',');
            if (content[1] && (!this.phoneReg(content[1]) && !this.telephone(content[1]))) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请填写正确的手机号';
              return;
            }
            if (content[2].split(' ').length < 3) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请填写正确的地址格式';
              return;
            }
            this.addressResolution(content[2]);
            this.addressObj.name = content[0];
            this.addressObj.phone = content[1];
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请按照格式填写正确地址';
          }
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请按照格式填写正确地址';
        }
      },

      // 阻止enter换行
      listenCode() {
        if (window.event.keyCode === 13) {
          window.event.preventDefault(); // 组织浏览器默认换行操作
          // this.submitBtn();
        }
      },

      // 获取省份下拉框
      getAllProvinceList() {
        this.$axios.get(this.Global.getAllProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.provincesList = res.data.resData;
          }
        });
      },

      // 获取城市下拉框
      getAllCityList() {
        this.selectCity = null;
        this.selectArea = null;
        if (this.selectProvince) {
          this.$axios.get(this.Global.getAllCityList(this.selectProvince)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cityList = res.data.resData;
            }
          });
        }
      },

      // 获取区下拉框
      getAllAreaList() {
        this.selectArea = null;
        if (this.selectCity) {
          this.$axios.get(this.Global.getAllAreaList(this.selectCity)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.areaList = res.data.resData;
            }
          });
        }
      },

      // 检索id位置下标
      findPosition(Id) {
        return this.goodsList.findIndex(item => {
          return item.Id === Id;
        });
      },

      // 失焦改变数量
      blurChaNum(Id, val) {
        const i = this.findPosition(Id);
        if (parseInt(val)) {
          val = parseInt(val);
        } else {
          val = 0;
        }
        if (parseInt(val) > this.goodsList[i].Stock) {
          val = this.goodsList[i].Stock;
        }
        this.updateCarGoods({
          index: i,
          key: 'Quantity',
          value: val
          // value: num + val <= 0 ? 1 : num + val
        });
      },

      // 改变数量
      changeNum(Id, val) {
        const i = this.findPosition(Id);
        let num = 0;
        if (parseInt(this.goodsList[i].Quantity)) {
          num = parseInt(this.goodsList[i].Quantity);
        } else {
          num = 0;
        }
        num = num + val;
        if ((num + val) < 0) {
          num = 0;
        }
        if (parseInt(num) > this.goodsList[i].Stock) {
          num = this.goodsList[i].Stock;
        }
        this.updateCarGoods({
          index: i,
          key: 'Quantity',
          value: num
          // value: num + val <= 0 ? 1 : num + val
        });
      },

      // 检验72小时内该收货人是否有订单
      checkReceiveNameHaveOrders() {if (!this.addressObj.name) {
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = '请填写收货人姓名';
        return;
      } else if (!this.addressObj.addressContent) {
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = '请填写收货详细地址';
        return;
      } else if (!this.addressObj.phone) {
        // } else if (!this.addressObj.phone && !this.tel) {
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = '请填写手机号';
        // this.txtMsg = '请填写手机或者固定电话其中一项联系方式';
        return;
      } else if (!this.selectProvince) {
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = '请选择省份';
        return;
      } else if (!this.selectCity) {
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = '请选择城市';
        return;
      }
        /* else if (!this.selectArea) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择城区';
          return;
        } */
        // 省份名
        if (!this.addressObj.provinceName) {
          const provincesIndex = this.provincesList.findIndex(item => {
            return this.selectProvince === item.id;
          });
          this.addressObj.provinceName = this.provincesList[provincesIndex].text;
        }
        // 城市名
        if (!this.addressObj.cityName) {
          const cityIndex = this.cityList.findIndex(item => {
            return this.selectCity === item.id;
          });
          this.addressObj.cityName = this.cityList[cityIndex].text;
        }
        // 区域名
        if (!this.addressObj.areaName) {
          const areaIndex = this.areaList.findIndex(item => {
            return this.selectArea === item.id;
          });
          if (areaIndex !== -1) {
            this.addressObj.areaName = this.areaList[areaIndex].text;
          }
        }
        this.$axios.post(this.Global.checkReceiveNameHaveOrders(this.addressObj.name), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.settlementOrder();
          } else {
            this.ctrlBtn('settlement', res.data.errorMsg);
          }
        });
      },

      // 零售订单结算 --- 购物车结算
      settlementOrder() {
        let params = {
          addressInfo: {
            receiver: this.addressObj.name,
            provinceId: this.selectProvince,
            provinceName: this.addressObj.provinceName,
            cityId: this.selectCity,
            cityName: this.addressObj.cityName,
            areaId: this.selectArea,
            areaName: this.addressObj.areaName,
            // address: this.addressObj.addressName,
            address: this.addressObj.addressContent,
            phone: this.addressObj.phone,
            tel: this.tel,
            postCode: this.postCode
          },
          remark: this.remark,
          detailList: []
        };
        // goodsList
        for (let i = 0; i < this.goodsList.length; i++) {
          if (this.goodsList[i].Quantity) {
            if (this.goodsList[i].Quantity > this.goodsList[i].Stock) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '数量不能大于库存';
              return;
            }
            params.detailList.push({
              goodsId: this.goodsList[i].GoodsId,
              skuId: this.goodsList[i].SkuId,
              storeroomId: this.goodsList[i].StoreroomId,
              quantity: this.goodsList[i].Quantity
            });
          }
        }
        if (params.detailList.length) {
          this.$axios.post(this.Global.settlementOrder, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.orderMsg = res.data.resData;
              this.orderLogisticTotal = 0;
              this.orderPriceTotal = 0;
              for (let i = 0; i < this.orderMsg.OrderList.length; i++) {
                // orderLogisticTotal
                // orderPriceTotal
                this.$set(this.orderMsg.OrderList[i], 'logisticPrice', 0);
                this.$set(this.orderMsg.OrderList[i], 'logisticIndex', -1);
                // this.orderMsg.OrderList[i].logisticPrice
                const defultIndex = this.orderMsg.OrderList[i].ExpressList.findIndex(item => {
                  return item.IsDefault === true;
                });
                if (defultIndex !== -1) {
                  this.orderMsg.OrderList[i].logisticIndex = defultIndex;
                  this.orderMsg.OrderList[i].logisticPrice = this.orderMsg.OrderList[i].ExpressList[defultIndex].Freight;
                }

                this.orderLogisticTotal = this.Global.addition(this.orderLogisticTotal, this.orderMsg.OrderList[i].logisticPrice);
              }
              this.orderPriceTotal = this.Global.addition(this.orderMsg.AllPayMoney, this.orderLogisticTotal);
              // document.getElementById('car').scrollTop = 0;
              this.type = 'list';
              this.getOrderSourceList();
              this.toTop();
              // console.log(this.orderMsg);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请添加商品';
        }
      },

      // 快递更换 --- 将快递下标赋值到订单里面的logisticIndex
      logisticExchange(orderIndex, logisticIndex) {
        this.orderMsg.OrderList[orderIndex].logisticIndex = logisticIndex;
        this.orderMsg.OrderList[orderIndex].logisticPrice = this.orderMsg.OrderList[orderIndex].ExpressList[logisticIndex].Freight;
        this.orderLogisticTotal = 0;
        this.orderPriceTotal = 0;
        for (let i = 0; i < this.orderMsg.OrderList.length; i++) {
          this.orderLogisticTotal = this.Global.addition(this.orderLogisticTotal, this.orderMsg.OrderList[i].logisticPrice);
        }
        this.orderPriceTotal = this.Global.addition(this.orderMsg.AllPayMoney, this.orderLogisticTotal);
      },

      // 获取平台来源下拉框信息
      getOrderSourceList() {
        this.$axios.get(this.Global.getOrderSourceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.sourceList = res.data.resData;
            this.sourceList.splice(0, 0, {id: '', text: '来源'});
            // this.selectSource = '';
            this.selectSource = '6';
          } else {
            this.sourceList = [];
            this.selectSource = res.data.errorMsg;
          }
        });
      },

      // 提交订单 --- 购物车提交订单
      submitOrders() {
        const params = {
          orderSource: this.selectSource,
          remark: this.orderMsg.Remark,
          addressInfo: {
            receiver: this.orderMsg.OrderList[0].ReceiverAddress.Receiver,
            provinceId: this.orderMsg.OrderList[0].ReceiverAddress.ProvinceId,
            provinceName: this.orderMsg.OrderList[0].ReceiverAddress.ProvinceName,
            cityId: this.orderMsg.OrderList[0].ReceiverAddress.CityId,
            cityName: this.orderMsg.OrderList[0].ReceiverAddress.CityName,
            areaId: this.orderMsg.OrderList[0].ReceiverAddress.AreaId,
            areaName: this.orderMsg.OrderList[0].ReceiverAddress.AreaName,
            address: this.orderMsg.OrderList[0].ReceiverAddress.Address,
            phone: this.orderMsg.OrderList[0].ReceiverAddress.Phone,
            tel: this.orderMsg.OrderList[0].ReceiverAddress.Tel,
            postCode: this.orderMsg.OrderList[0].ReceiverAddress.PostCode
          },
          orderList: []
        };
        for (let i = 0; i < this.orderMsg.OrderList.length; i++) {
          if (this.orderMsg.OrderList[i].logisticIndex === -1) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '每个订单都必须选一个物流';
            return;
          } else {
            params.orderList.push({
              orderNum: this.orderMsg.OrderList[i].OrderNum,
              logistic: this.orderMsg.OrderList[i].ExpressList[this.orderMsg.OrderList[i].logisticIndex].LogisticId,
              detailList: []
            });
            for (let j = 0; j < this.orderMsg.OrderList[i].GoodsDetailList.length; j++) {
              params.orderList[i].detailList.push({
                goodsId: this.orderMsg.OrderList[i].GoodsDetailList[j].GoodsId,
                skuId: this.orderMsg.OrderList[i].GoodsDetailList[j].SkuId,
                storeroomId: this.orderMsg.OrderList[i].GoodsDetailList[j].StoreroomId,
                quantity: this.orderMsg.OrderList[i].GoodsDetailList[j].Quantity
              })
            }
          }
        }
        if (!this.selectSource) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择来源';
          return;
        }
         this.$axios.post(this.Global.submitOrders, params).then((res) => {
           if (!res.data.errorMsg.length) {
             this.isMsg = true;
             this.isSuc = true;
             this.txtMsg = '订单提交成功';
             this.addressObj.addressDetailContent = null;
             this.addressObj.name = null;
             this.postCode = null;
             this.selectProvince = null;
             this.selectCity = null;
             this.selectArea = null;
             this.addressObj.addressContent = null;
             this.addressObj.phone = null;
             this.tel = null;
             this.remark = null;
             this.addressObj.provinceName = '';
             this.addressObj.cityName = '';
             this.addressObj.areaName = '';
             this.addressObj.addressName = '';
             this.cityList = [];
             this.areaList = [];
             this.orderRemark = '';
             this.orderPriceTotal = 0;
             this.orderLogisticTotal = 0;
             this.clearCarGoods();
             // document.getElementById('car').scrollTop = 0;
             // this.type = 'car';
           } else {
             this.isMsg = true;
             this.isSuc = false;
             this.txtMsg = res.data.errorMsg;
           }
         });
      },

      // 跳转订单页且删除购物车的tabs
      toOrder() {
        this.$router.push({
          path: '/home/o_list'
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '细化订单列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/o_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
        let indexCar = -1;
        indexCar = this.rightTabsContent.findIndex(item => {
          return item.title === '购物车';
        });
        this.rightTabsContent.splice(indexCar, 1);
      },

      // 取消
      cancle() {
        this.type = 'car';
        this.toTop();
      },

      // 回到顶部
      toTop() {
        if (document.getElementById('car')) {
          document.getElementById('car').scrollTop = 0;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.showType === 'settlement' && e.handleType === true) {
          this.settlementOrder();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.toTop();
          this.type = 'car';
          this.toOrder();
        }
      }
    },
    created() {
      this.type = 'car';
      this.getAllProvinceList();
      if (this.goodsList.length) {
        for (let i = 0; i < this.goodsList.length; i++) {
          this.priceTotal = this.Global.addition(this.priceTotal, this.goodsList[i].actualAmount);
        }
      }
    },
    activated() {
      if (!this.goodsList.length || !this.$route.query['clear']) {
        this.addressObj.provinceName = '';
        this.addressObj.cityName = '';
        this.addressObj.areaName = '';
        this.addressObj.addressName = '';
        this.addressObj.name = null;
        this.addressObj.phone = null;
        this.addressObj.addressDetailContent = null;
        this.addressObj.addressContent = null;
        this.postCode = null;
        this.selectProvince = null;
        this.selectCity = null;
        this.selectArea = null;
        this.cityList = [];
        this.areaList = [];
        this.tel = '';
        this.remark = '';
        this.orderRemark = '';
        this.orderPriceTotal = 0;
        this.orderLogisticTotal = 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/style";
  @import "../../../assets/css/home-view";

.car {
  background-color: #ffffff;
  height: calc(100% - 12px);
  padding: 10px 5px 0;
  overflow: auto;

  .table {
    th {
      background-color: rgb(234, 237, 241);
    }

    .car_number {
      input[type='text'] {
        text-align: center;
        width: 30px;
        padding: 0 5px;
      }
    }

    &.consignee_msg {
      margin-top: 20px;
      border-top: 1px solid #eeeeee;

      td{
        border: 1px solid #eeeeee;

        &:first-child {
          width: 20%;
          text-align: right;
        }

        &:nth-child(2) {
          width: 80%;
          text-align: left;
        }

        textarea {
          width: 80%;
          height: 70px;
          padding: 5px;

          &.detail_address {
            height: 16px;
          }
        }

        input[type="text"] {
          width: 40%;
        }

        .address_analysis {
          background-color: #F2FFEA;
          padding: 5px;
          margin-top: 5px;
        }
      }
    }
  }

  .list_msg {
    .table {
      thead tr:nth-child(1) th {
        text-align: left;
        border-bottom: 1px solid #ddd;
      }

      th, td {
        border: 1px solid #eeeeee;
      }

      .logistics_top {
        background-color: #ddd;
      }

      .default {
        background-color: deepskyblue;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .list_detail {
      text-align: right;
      background-color: #eeeeee;
      margin:10px 0;
      padding: 10px;

      p {
        line-height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/car.vue